import { useContext } from "react";
import { BotFormContext } from "@shared/features/bots/BotForm/common/BotForm.context";
import { BotType, LanguageNameSpaces } from "@shared/types";
import {
  StrategyOrder,
  SummaryData,
  ToggleField,
} from "@shared/features/bots/BotForm/common/types";
import { OrderTypes } from "@shared/features/trades/common/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { ANALYTICS_FIELD_NAMES } from "@shared/features/bots/BotForm/common/constants";

const useStopSummary = (): SummaryData => {
  const { botType, isFetching, checkedFields, parsedStop } =
    useContext(BotFormContext)!;
  const { t } = useTypedTranslation(LanguageNameSpaces.BOTS);

  let stopOrders: StrategyOrder[] = parsedStop ? [parsedStop] : [];

  const priceColumnName =
    botType === BotType.TRADING_VIEW || botType === BotType.TRADING_VIEW_SIGNALS
      ? [
          t("ordersSummary.columns.distance_from"),
          t("ordersSummary.columns.first_entry_trigger"),
        ]
      : undefined;

  return {
    key: "stop",
    title: t(ANALYTICS_FIELD_NAMES[OrderTypes.STOP]),
    orders: stopOrders,
    isFetching,
    showPrice: botType === BotType.ASAP,
    amountColumnName: t("ordersSummary.columns.ratio"),
    priceColumnName,
    orderType: OrderTypes.STOP,
    botType,
    shouldDisplay: checkedFields.has(ToggleField.STOP),
  };
};

export default useStopSummary;
